import CCPAHeader from "@/components/CCPAHeader/CCPAHeader.vue";
import CCPAFooter from "@/components/CCPAFooter/CCPAFooter.vue";

export default {
    components: {
        CCPAHeader,
        CCPAFooter,
    },
};



// WEBPACK FOOTER //
// ./src/layouts/CCPAStatic/CCPAStatic.js